import { useParams } from 'react-router-dom';

export default function useCheckIfPageIsUpgrade() {
	const { idFinanceiro } = useParams<any>();
	const isUpgradePage = idFinanceiro !== undefined;

	return { isUpgradePage };
}
